import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f9222ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "event-card__header"
}
const _hoisted_2 = { class: "headline-4" }
const _hoisted_3 = { class: "event-card__fetching" }
const _hoisted_4 = {
  key: 0,
  class: "event-card__body"
}
const _hoisted_5 = { class: "experience-search__title" }
const _hoisted_6 = { class: "event-card__date-row" }
const _hoisted_7 = { class: "event-card__date-row-item" }
const _hoisted_8 = {
  key: 0,
  class: "event-card__availabilities-loading"
}
const _hoisted_9 = { class: "event-card__date-row-item" }
const _hoisted_10 = {
  key: 0,
  class: "event-card__cancelled"
}
const _hoisted_11 = {
  key: 1,
  class: "event-card__sale-ended"
}
const _hoisted_12 = {
  key: 0,
  class: "event-card__items"
}
const _hoisted_13 = { class: "event-card__items-row" }
const _hoisted_14 = {
  key: 0,
  class: "event-card__items-price"
}
const _hoisted_15 = {
  key: 0,
  class: "event-card__label"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "event-card__quantity-wrapper" }
const _hoisted_18 = {
  key: 0,
  class: "event-card__package-label"
}
const _hoisted_19 = {
  key: 1,
  class: "event-card__total-selected"
}
const _hoisted_20 = {
  key: 2,
  class: "event-card__group-size-info"
}
const _hoisted_21 = {
  key: 3,
  class: "event-card__period"
}
const _hoisted_22 = { class: "event-card__label" }
const _hoisted_23 = { class: "event-card__label" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "event-card__divider" }, null, -1))
const _hoisted_25 = { class: "event-card__expandable-section" }
const _hoisted_26 = { class: "event-card__expandable-header" }
const _hoisted_27 = {
  key: 0,
  class: "event-card__additional-service-list"
}
const _hoisted_28 = {
  key: 5,
  class: "event-card__divider"
}
const _hoisted_29 = {
  key: 6,
  class: "event-card__expandable-section"
}
const _hoisted_30 = { class: "event-card__expandable-header" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "event-card__divider" }, null, -1))
const _hoisted_32 = {
  key: 1,
  class: "event-card__footer"
}
const _hoisted_33 = { class: "event-card__total" }
const _hoisted_34 = {
  key: 0,
  class: "event-card__total-price"
}
const _hoisted_35 = {
  key: 0,
  class: "event-card__label"
}
const _hoisted_36 = { class: "event-card__prices-wrapper" }
const _hoisted_37 = {
  key: 0,
  class: "event-card__price event-card__price--base event-card__price--discounted"
}
const _hoisted_38 = { class: "event-card__action" }

import AdditionalServiceCard from '@/components/public/AdditionalServiceCard.vue'
import BaseNumberIncrementer from '../BaseNumberIncrementer.vue'
import BaseCountdown from '@/components/misc/BaseCountdown.vue'
import BaseSelect from '@/components/BaseSelect.vue'
import DatePicker from '@/components/DatePicker.vue'
import BaseButton from '../BaseButton.vue'
import BaseIcon from '../BaseIcon.vue'
import EventSelectionOverview from '@/components/public/event/EventSelectionOverview.vue'
import parseISO from 'date-fns/parseISO'
import debounce from 'lodash/debounce'
import format from 'date-fns/format'
import endOfMonth from 'date-fns/endOfMonth'
import { computed, ref, watch, reactive, onMounted, PropType } from 'vue'
import {
  useFetchEventDetailedAvailability,
  useFetchServiceEventInformationMutation,
  useQueryEventPeriodAvailability,
} from '@/queries/public/services'
import {
  formatCurrency,
  formatDateTime,
  formatSameDay,
  formatIntlDateAndTime,
} from '@/utils/formatters'
import { ALERT_TYPES, FORMATS, SIZES } from '@/enums/components'
import {
  EventInformation,
  EventPeriodAvailabilityPayload,
  EventTimeSlot,
  SalesItemInformationWithQuantity,
} from '@/models/public/service.model'
import { getValidationErrorData } from '@/utils/errors'
import { Alert, StringDate, Option } from '@/models/shared.model'
import {
  useCreateOrderMutation,
  createOrUpdateEventServiceOrderItem,
} from '@/queries/cart'
import { OrderItem } from '@/models/public/order.model'
import { useOrderStore } from '@/store/order'
import { useToast } from 'vue-toastification'
import { useI18n } from 'vue-i18n'
import { isNumeric } from '@/utils/general'
import {
  ORDER_ITEM_PRICE_LINE_TYPE,
  serviceResultCardCommonProps,
} from '@/enums/public'
import { AdditionalServiceInformationWithQuantity } from './AdditionalServiceCard.vue'
import { useRoute } from 'vue-router'
import { TRANSLATION_TYPE } from '@/enums/public'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventResultCard',
  props: {
  ...serviceResultCardCommonProps,
  selectedDate: {
    type: Date as PropType<Date | null>,
    default: null,
  },
  selectedGroupSize: {
    type: Number as PropType<number | undefined>,
    default: undefined,
  },
},
  emits: ['cartUpdated', 'payloadUpdated'],
  setup(__props, { emit: emits }) {

const props = __props

const orderStore = useOrderStore()
const i18n = useI18n()
const toast = useToast()
const route = useRoute()



const salesItemQuantities = reactive<Record<string, number>>({})
const additionalServiceQuantities = reactive<Record<string, number>>({})
const requests = ref<string>('')
const selectedDate = ref<Date | null>(props.selectedDate) // watch prop change

const eventInfo = ref<EventInformation | undefined>(undefined)
const isAdditionalServicesExpanded = ref<boolean>(true)
const isRequestsExpanded = ref<boolean>(false)
const isAddToCartLoading = ref<boolean>(false)
const errors = ref<Record<string, unknown> | undefined>(undefined)

const alerts = computed<Alert[]>(() => {
  const alertList: Alert[] = []
  const nonFieldErrors = (errors.value?.non_field_errors || []) as Array<string>
  for (const errorMessage of nonFieldErrors) {
    alertList.push({
      text: errorMessage,
      alertType: ALERT_TYPES.DANGER,
    })
  }
  return alertList
})

const isCancelled = computed<boolean>(() => {
  return !!eventInfo.value?.cancelled_at
})

const isSalesEnded = computed<boolean>(() => {
  if (!eventInfo.value?.sale_ends_at) {
    return false
  }
  const saleEndsAt = parseISO(eventInfo.value?.sale_ends_at)
  const currentMoment = new Date()
  return currentMoment > saleEndsAt
})

const canDisplayEventInformation = computed(() => {
  return (
    selectedDate.value &&
    selectedTimeSlot.value &&
    eventInfo.value &&
    !isSalesEnded.value &&
    !isCancelled.value
  )
})

const { mutateAsync: fetchEventInfo, isLoading: isLoadingEventInfo } =
  useFetchServiceEventInformationMutation(
    props.service.hash_id,
    props.isPreview,
    salesItemQuantities,
    additionalServiceQuantities,
    props.groupService,
  )

const propagateSalesItems = () => {
  if (!eventInfo.value && !props.selectedGroupSize) return
  const salesItems = eventInfo.value?.sales_items || []

  salesItems.forEach((item) => {
    salesItemQuantities[item.identifier] = Math.min(
      props.selectedGroupSize,
      getSalesItemMaxQuantity(item),
    )
  })
}

const updateEventInfo = (eventId: number) => {
  fetchEventInfo(eventId)
    .then((data) => {
      eventInfo.value = data

      if (Object.keys(salesItemQuantities).length === 0) {
        propagateSalesItems()
      }
    })
    .catch((error) => {
      errors.value = getValidationErrorData(error)
    })
}

// Use this to get updates in controlled amount after group size changes.
const debouncedUpdateEventInfo = debounce(updateEventInfo, 400)

const groupSize = computed<number>(() => {
  return Object.values(salesItemQuantities).reduce(
    (a, b) => Number(a) + Number(b),
    0,
  )
})

const leftoverAvailability = computed<number>(() => {
  return maxGroupSize.value - groupSize.value
})

const maxGroupSize = computed<number>(() => {
  return eventInfo.value?.available_capacity ?? 0
})

const minCapacity = computed<number>(() => {
  return eventInfo.value?.min_capacity ?? 1
})

const boughtTickets = computed<number>(() => {
  if (eventInfo.value?.max_capacity && eventInfo.value?.available_capacity) {
    return eventInfo.value?.max_capacity - eventInfo.value?.available_capacity
  }
  return 0
})

const minCapacitySatisfied = computed<number>(() => {
  return boughtTickets.value >= minCapacity.value
})

const cancelTime = computed<string>(() => {
  return formatDateTime(eventInfo.value?.cancel_at, {
    format: 'yyyy-MM-dd HH:mm',
  })
})

const isDiscounted = computed<boolean>(() => {
  return eventInfo.value?.base_total !== eventInfo.value?.discounted_total
})

const getSalesItemMaxQuantity = (
  salesItem: SalesItemInformationWithQuantity,
) => {
  const totalLeftoverAvailability =
    (salesItem.quantity || 0) + leftoverAvailability.value
  if (salesItem.event_package_group_size) {
    return Math.min(
      salesItem.event_package_group_size,
      totalLeftoverAvailability,
    )
  }
  return totalLeftoverAvailability
}

const additionalServicesWithQuantities = computed<
  AdditionalServiceInformationWithQuantity[]
>(() => {
  const additionalServices = eventInfo.value?.additional_services || []

  return additionalServices.map((item) => {
    return {
      ...item,
      quantity: additionalServiceQuantities[item.id] || 0,
    }
  })
})

const salesItemsWithQuantities = computed<SalesItemInformationWithQuantity[]>(
  () => {
    const salesItems = eventInfo.value?.sales_items || []

    return salesItems.map((item) => {
      return {
        ...item,
        quantity:
          salesItemQuantities[item.identifier] || props.selectedGroupSize || 0,
      }
    })
  },
)

const anySelected = computed<boolean>(() => {
  return salesItemsWithQuantities.value.some((item) => item.quantity > 0)
})

const currentDate = new Date(new Date().getFullYear(), new Date().getMonth())

const calendarDate = ref(
  new Date(new Date().getFullYear(), new Date().getMonth()),
)

const eventPeriodAvailabilityPayload = computed<EventPeriodAvailabilityPayload>(
  () => {
    calendarDate.value
    return {
      start: format(calendarDate.value, 'yyyy-MM-dd'),
      end: format(endOfMonth(calendarDate.value), 'yyyy-MM-dd'),
      group_service: props.groupService,
    }
  },
)

const {
  data: calendarAvailability,
  isLoading: isLoadingEventPeriodAvailability,
} = useQueryEventPeriodAvailability(
  ref(props.service.hash_id),
  eventPeriodAvailabilityPayload,
)

const {
  mutateAsync: fetchEventDetailedAvailability,
  isLoading: isEventTimeslotsLoading,
} = useFetchEventDetailedAvailability(ref(props.service.hash_id))

const eventTimeslots = ref<EventTimeSlot[] | null>(null)

const timeslotOptions = computed<Option[]>(() => {
  if (!eventTimeslots.value) {
    return []
  }
  return eventTimeslots.value.map((timeslot: EventTimeSlot) => {
    return {
      id: timeslot.id,
      key: `${timeslot.start_at}-${timeslot.end_at}`,
      label: formatSameDay(timeslot.start_at, timeslot.end_at),
    }
  })
})

const updateEventTimeslots = (date: Date | StringDate | null) => {
  if (date === null) {
    return
  }

  // Is returned so it can be handeld as Promise
  return fetchEventDetailedAvailability(date)
    .then((data) => {
      eventTimeslots.value = data
      return data
    })
    .catch((error) => {
      console.error(error)
      return []
    })
}

// For which date should we fetch timeslots availabilities for.
const selectedTimeSlot = ref<Option | null>(timeslotOptions.value[0] || null)

const datePickerMonthYearChange = ({
  month,
  year,
}: {
  month: number
  year: number
}) => {
  calendarDate.value = new Date(year, month)
}

const isLoadingEventInformation = computed(() => {
  return isLoadingEventPeriodAvailability.value
})

const payload = computed(() => {
  return {
    service: props.service.id,
    requests: requests.value,
    sales_items: salesItemQuantities,
    additional_services: additionalServiceQuantities,
    event: selectedTimeSlot.value?.id,
    referral_type: props.referral?.referral_type,
    referral_code: props.referral?.referral_code,
    item_group: null,
  }
})

function resetMonthYear() {
  // lets check if selected month is not empty and not send any more availability requests if it has already dates
  if (!calendarAvailability || !calendarAvailability.value) {
    calendarDate.value = currentDate
  } else return
}

const getIsDateDisabled = (date: Date): boolean => {
  const dateStr: StringDate = formatDateTime(date)
  return calendarAvailability.value
    ? !calendarAvailability.value.includes(dateStr)
    : false
}

const { mutateAsync: createOrder } = useCreateOrderMutation()

const addEventServiceItemToCart = async () => {
  isAddToCartLoading.value = true
  errors.value = undefined
  if (!orderStore.orderUuid) {
    try {
      const data = await createOrder()
      orderStore.updateOrder(data)
    } catch (error: unknown) {
      errors.value = getValidationErrorData(error)
      isAddToCartLoading.value = false
      return
    }
  }

  createOrUpdateEventServiceOrderItem(orderStore.orderUuid, payload.value)
    .then((response) => {
      orderStore.updateOrder(response.data)
      toast.success(i18n.t('addToCartSuccess'))
      emits('cartUpdated')
    })
    .catch((error) => {
      errors.value = getValidationErrorData(error)
    })
    .finally(() => {
      isAddToCartLoading.value = false
    })
}

const matchingItemInCart = computed<OrderItem | undefined>(() => {
  for (const item of orderStore.items) {
    // Shouldn't match against order item that is part of a group
    if (item.item_group !== null) {
      continue
    }
    if (item.service_event === selectedTimeSlot.value.id) {
      return item
    }
  }
  return undefined
})

function getCartOrderItem() {
  requests.value = matchingItemInCart.value?.requests || ''
  for (const line of matchingItemInCart.value.lines) {
    if (line.type === ORDER_ITEM_PRICE_LINE_TYPE.EVENT) {
      if (line.object_id) {
        salesItemQuantities[line.identifier_id] = line.quantity
      }
    }
    if (line.type === ORDER_ITEM_PRICE_LINE_TYPE.ADDITIONAL_SERVICE) {
      if (line.object_id) {
        additionalServiceQuantities[line.object_id] = line.quantity
      }
    }
  }
}

watch(selectedTimeSlot, () => {
  if (selectedDate.value && selectedTimeSlot.value) {
    if (
      matchingItemInCart.value &&
      matchingItemInCart.value.service_event === selectedTimeSlot.value.id
    ) {
      // Fetch from orderStore if event is added to cart
      getCartOrderItem()
    } else {
      if (eventInfo.value) {
        // Clear inputs if timeslot is changed
        for (const key in salesItemQuantities) {
          Object.assign(salesItemQuantities, {
            [key]: props.selectedGroupSize || 0,
          })
        }
        // Set all object keys to 0
        for (const key in additionalServiceQuantities) {
          Object.assign(additionalServiceQuantities, { [key]: 0 })
        }
        debouncedUpdateEventInfo(selectedTimeSlot.value.id)
      } else {
        debouncedUpdateEventInfo(selectedTimeSlot.value.id)
      }
    }
  }
})

// Fetch new prices when inputs have been changed
watch([groupSize, additionalServiceQuantities], () => {
  debouncedUpdateEventInfo(selectedTimeSlot.value.id)
})

onMounted(async () => {
  // Fetch orderitems(ServiceEvent) information and set Date and TimeSlot accordingly
  if (route.query.event) {
    fetchEventInfo(route.query.event)
      .then((data) => {
        eventInfo.value = data
        // Set date automatically
        selectedDate.value = parseISO(data.start)

        // Fetch time slots and set automatically
        updateEventTimeslots(selectedDate.value)?.then(() => {
          selectedTimeSlot.value =
            timeslotOptions.value.find(
              (timeslot) => String(timeslot.id) === route.query.event,
            ) ?? null
        })
      })
      .catch((error) => {
        errors.value = getValidationErrorData(error)
      })
  }
})

watch(
  () => props.selectedDate,
  () => {
    selectedDate.value = props.selectedDate
  },
)

watch(
  selectedDate,
  (newValue) => {
    updateEventTimeslots(newValue)
  },
  {
    immediate: true,
  },
)

watch(eventTimeslots, (newValue) => {
  // Set time slot to null if its not in options
  if (selectedTimeSlot.value) {
    const timeSlotInOptions = (newValue || []).find(
      (timeslot) => timeslot.id === selectedTimeSlot.value?.id,
    )
    if (!timeSlotInOptions) selectedTimeSlot.value = null
  }
})

watch(
  payload,
  () => {
    emits('payloadUpdated', payload.value)
  },
  { immediate: true },
)



return (_ctx: any,_cache: any) => {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_AlertBanner = _resolveComponent("AlertBanner")!
  const _component_BaseInput = _resolveComponent("BaseInput")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["event-card", { 'result-card--grouped': !!props.groupService }])
  }, [
    _renderSlot(_ctx.$slots, "header", {}, () => [
      (!_ctx.hideHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(_ctx.service.name?.content) + " ", 1),
              (_ctx.service.name?.type === _unref(TRANSLATION_TYPE).MACHINE)
                ? (_openBlock(), _createBlock(BaseIcon, {
                    key: 0,
                    icon: "google-translate",
                    style: {"height":"16px","width":"revert","display":"block"}
                  }))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_3, [
              _createVNode(_component_LoadingSpinner)
            ], 512), [
              [_vShow, _unref(isLoadingEventInfo)]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.showSelectedMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alerts), (alert, alertIndex) => {
            return (_openBlock(), _createBlock(_component_AlertBanner, _mergeProps({ key: alertIndex }, alert), null, 16))
          }), 128)),
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t('whenAreYouGoing')), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(DatePicker, {
                modelValue: selectedDate.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
                label: _ctx.$t('date'),
                "min-date": new Date(),
                "month-change-on-scroll": false,
                "month-change-on-arrows": false,
                "disabled-dates": getIsDateDisabled,
                "keep-action-row": "",
                name: "date",
                errors: errors.value?.birth_date,
                disabled: _ctx.isPreview,
                onUpdateMonthYear: datePickerMonthYearChange,
                onRecalculatePosition: resetMonthYear
              }, {
                "action-preview": _withCtx(() => [
                  (_unref(isLoadingEventInformation))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_LoadingSpinner),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('bookingForm.loadingDatePickerTimeslots')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                "action-select": _withCtx(() => []),
                _: 1
              }, 8, ["modelValue", "label", "min-date", "errors", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(BaseIcon, {
                icon: "clock-clockwise",
                size: 20
              }),
              (_unref(isEventTimeslotsLoading))
                ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
                : (_openBlock(), _createBlock(BaseSelect, {
                    key: 1,
                    "model-value": selectedTimeSlot.value,
                    options: _unref(timeslotOptions),
                    label: _ctx.$t('bookingForm.fields.timeslots'),
                    placeholder: _ctx.$t('bookingForm.fields.timeslots'),
                    "close-on-select": "",
                    class: "event-card__date-select",
                    name: "timeslots",
                    disabled: !selectedDate.value || _ctx.isPreview,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = 
                (value) =>
                  (selectedTimeSlot.value = _unref(timeslotOptions).find(
                    (option) => option.key === value,
                  ))
              )
                  }, null, 8, ["model-value", "options", "label", "placeholder", "disabled"]))
            ])
          ]),
          (_unref(isCancelled))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_AlertBanner, {
                  text: _ctx.$t('eventService.eventIsCancelled'),
                  "alert-type": _unref(ALERT_TYPES).INFO
                }, null, 8, ["text", "alert-type"])
              ]))
            : (_unref(isSalesEnded))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_AlertBanner, {
                    text: _ctx.$t('eventService.eventSalesEnded'),
                    "alert-type": _unref(ALERT_TYPES).INFO
                  }, null, 8, ["text", "alert-type"])
                ]))
              : (_unref(canDisplayEventInformation))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (!_unref(isLoadingEventInformation))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(salesItemsWithQuantities), (salesItem) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: salesItem.id,
                              class: "event-card__items-row-data-wrapper"
                            }, [
                              _createElementVNode("div", _hoisted_13, [
                                (!_ctx.isPriceHidden)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                      (salesItem.name?.content)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(salesItem.name?.content) + ": ", 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(salesItem.name) + ": ", 1)),
                                      _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(salesItem.price)), 1),
                                      (salesItem.name?.type === _unref(TRANSLATION_TYPE).MACHINE)
                                        ? (_openBlock(), _createBlock(BaseIcon, {
                                            key: 2,
                                            icon: "google-translate",
                                            style: {"height":"16px","width":"130px","display":"block"}
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createVNode(BaseNumberIncrementer, {
                                  amount: salesItem.quantity,
                                  "min-amount": 0,
                                  "max-amount": getSalesItemMaxQuantity(salesItem),
                                  class: "event-card__incrementer-field",
                                  onClickMinus: 
                  () =>
                    (salesItemQuantities[salesItem.identifier] = Math.max(
                      0,
                      salesItem.quantity - 1,
                    ))
                ,
                                  onClickPlus: 
                  () =>
                    (salesItemQuantities[salesItem.identifier] = Math.max(
                      0,
                      salesItem.quantity + 1,
                    ))
                
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_17, _toDisplayString(salesItem.quantity), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["amount", "max-amount", "onClickMinus", "onClickPlus"])
                              ]),
                              (salesItem.event_package_group_size)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t('eventResultCard.packagePriceLabel', {
                  maxGroupSize: salesItem.event_package_group_size,
                })), 1))
                                : _createCommentVNode("", true),
                              (errors.value?.sales_items?.[salesItem.identifier])
                                ? (_openBlock(), _createBlock(_component_AlertBanner, {
                                    key: 1,
                                    "alert-type": _unref(ALERT_TYPES).WARNING,
                                    text: errors.value?.sales_items?.[salesItem.identifier][0],
                                    class: "event-card__alert"
                                  }, null, 8, ["alert-type", "text"]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (!_unref(isLoadingEventInformation))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t('participants.maxGroupSizeText', { maxGroupSize: _unref(maxGroupSize), groupSize: _unref(groupSize) })), 1))
                      : _createCommentVNode("", true),
                    (!_unref(isLoadingEventInformation) && !_unref(minCapacitySatisfied))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('availableTickets', { maxGroupSize: _unref(maxGroupSize) })), 1),
                          (_unref(cancelTime))
                            ? (_openBlock(), _createBlock(BaseCountdown, {
                                key: 0,
                                to: new Date(_unref(cancelTime))
                              }, {
                                countdown: _withCtx(({ formattedText }) => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('eventCancelAtInfo', {
                    minCapacity: _unref(minCapacity),
                    cancelDuration: formattedText,
                  })), 1)
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (!_unref(isLoadingEventInformation))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('start')) + ": ", 1),
                          _createElementVNode("span", null, _toDisplayString(_unref(formatIntlDateAndTime)(eventInfo.value?.start)), 1),
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('end')) + ": ", 1),
                          _createElementVNode("span", null, _toDisplayString(_unref(formatIntlDateAndTime)(eventInfo.value?.end)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (
            _unref(additionalServicesWithQuantities).length &&
            !_unref(isLoadingEventInformation)
          )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _hoisted_24,
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(BaseButton, {
                                label: _ctx.$t('additionalServices'),
                                format: _unref(FORMATS).TERTIARY,
                                size: _unref(SIZES).MEDIUM,
                                icon: isRequestsExpanded.value ? 'chevron-up' : 'chevron-down',
                                "icon-right": true,
                                class: "event-card__section-toggle",
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
                  isAdditionalServicesExpanded.value = !isAdditionalServicesExpanded.value
                ), ["prevent"]))
                              }, null, 8, ["label", "format", "size", "icon"])
                            ]),
                            (isAdditionalServicesExpanded.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(additionalServicesWithQuantities), (item) => {
                                    return (_openBlock(), _createBlock(AdditionalServiceCard, {
                                      key: item.id,
                                      "model-value": item,
                                      "onUpdate:modelValue": 
                  (item) =>
                    (additionalServiceQuantities[item.id] = item.quantity)
                
                                    }, null, 8, ["model-value", "onUpdate:modelValue"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (!_unref(isLoadingEventInformation))
                      ? (_openBlock(), _createElementBlock("hr", _hoisted_28))
                      : _createCommentVNode("", true),
                    (!_unref(isLoadingEventInformation))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(BaseButton, {
                              label: _ctx.$t('specialRequest'),
                              format: _unref(FORMATS).TERTIARY,
                              size: _unref(SIZES).MEDIUM,
                              icon: isRequestsExpanded.value ? 'chevron-up' : 'chevron-down',
                              "icon-right": true,
                              class: "event-card__section-toggle",
                              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (isRequestsExpanded.value = !isRequestsExpanded.value), ["prevent"]))
                            }, null, 8, ["label", "format", "size", "icon"])
                          ]),
                          (isRequestsExpanded.value)
                            ? (_openBlock(), _createBlock(_component_BaseInput, {
                                key: 0,
                                modelValue: requests.value,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((requests).value = $event)),
                                label: _ctx.$t('requests'),
                                name: "requests",
                                class: "event-card__requests",
                                type: "textarea",
                                resizable: "",
                                errors: errors.value?.requests
                              }, null, 8, ["modelValue", "label", "errors"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_31
                  ], 64))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(canDisplayEventInformation))
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            (!_ctx.isPriceHidden)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  (!_ctx.showSelectedMode)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t('eventResultCard.priceForGroupText', {
              groupSize: _unref(groupSize),
            })), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_36, [
                    (_unref(isDiscounted))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_unref(isNumeric)(eventInfo.value?.base_total)
                  ? _unref(formatCurrency)(eventInfo.value?.base_total)
                  : '- €'), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: _normalizeClass(["event-card__price", [_unref(isDiscounted) && 'event-card__price--discounted']])
                    }, _toDisplayString(_unref(isNumeric)(eventInfo.value?.discounted_total)
                  ? _unref(formatCurrency)(eventInfo.value?.discounted_total)
                  : '- €'), 3)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showSelectedMode && eventInfo.value !== undefined)
              ? (_openBlock(), _createBlock(EventSelectionOverview, {
                  key: 1,
                  start: eventInfo.value.start,
                  end: eventInfo.value.end,
                  "group-size": _unref(groupSize),
                  "additional-services": additionalServiceQuantities
                }, null, 8, ["start", "end", "group-size", "additional-services"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _renderSlot(_ctx.$slots, "addButton", {
              payload: _unref(payload),
              contentSelected: _unref(anySelected)
            }, () => [
              _createVNode(BaseButton, {
                format: _unref(FORMATS).PRIMARY,
                size: _unref(SIZES).SMALL,
                label: _unref(matchingItemInCart) ? _ctx.$t('updateInCart') : _ctx.$t('addToCart'),
                loading: isAddToCartLoading.value,
                class: _normalizeClass(["event-card__action", 
              _unref(matchingItemInCart)
                ? 'event-card__action--update'
                : 'event-card__action--add'
            ]),
                icon: "shopping-cart",
                disabled: _ctx.isPreview || !_ctx.service.id,
                "icon-right": "",
                onClick: _withModifiers(addEventServiceItemToCart, ["prevent"])
              }, null, 8, ["format", "size", "label", "loading", "class", "disabled", "onClick"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})